
export const CALENDAR_DATE_FORMAT = 'ddd D MMM \'YY';
export const EXPECTED_PRICE_TRACKER_DATE_FORMAT = 'ddd D MMM YYYY';



/** WEBPACK FOOTER **
 ** ./src/constants/dates.js
 **/